<template>
    <nav class="action">
      <ul>
        <li @click="voltar('adicionar')" class="button">&#10010; ADICIONAR ITENS</li>
        <li @click="voltar('ofertas')" class="button">&#x2739; OFERTAS</li>
        <li @click="voltar('limpar')" class="button">&#10006; LIMPAR LISTA</li>
        <li @click="voltar('enviar')" class="button" id="enviar">&#10004; ENVIAR PEDIDO</li>
      </ul>
    </nav>
</template>

<script>

export default {
  name: 'ActionHeader',
  components: {
  },
  methods: {
    voltar (acao) {
      this.$emit('voltar', acao)
    }
  }
}
</script>

<style lang="scss">
  nav.action {
    background: #C2171A;
    position: relative;
    color: #fff;
    width: fill-available;
    overflow: hidden;
    margin: 0;

    ul {
      list-style: none;
    }
    ul li {
      display: inline-flex;
      flex-wrap: wrap;
      align-self: stretch;
      float:left;
      font-size: 1rem;
      margin: 0.5rem;
      margin-right: 1rem;
      margin-left: 1rem;
      text-align: center;
    }
    /* For width 400px and larger: */
    @media only screen and (min-width: 400px) {
      ul li {
        float:left;
        font-size: 1.5rem;
        display: inline-flex;
      }
    }
    li#enviar {
        float: right;
    }
    li.button:hover {
        color: #FFEC00;
    }
    .link
    {
      text-decoration-color: yellow;
      text-decoration:none;
    }
  }
</style>
